import { useMediaLibraryFirstPageTotal } from "./useMediaLibraryFirstPageTotal"

export function useIsEmptyMediaLibrary() {
  const total = useMediaLibraryFirstPageTotal()

  return total === 0
}
